import {AppConfig, ElementDesign} from '../interfaces/biozoom-api/app-configuration';
import {getKeyVal} from './helpers';
const _ = require('lodash');

const deleteKey = (key: string, obj: any) => {
  const keySplit = key.split('.');
  let it = obj;
  for (const k of keySplit.slice(0, keySplit.length - 1)) {
    it = it[k];
    if (it === undefined) {
      break;
    }
  }
  if (it === undefined || it === null) {
    return;
  }
  delete it[keySplit[keySplit.length - 1]];
};

const mergeSubElement = (elementIn: Record<string, any>, elementTemplate: Record<string, any>) => {
  const elementOut = {...elementIn};
  for (const [key, value] of Object.entries(elementTemplate)) {
    if (!(Object.keys(elementOut).includes(key)) || [null, undefined, ''].includes(elementOut[key])) {
      elementOut[key] = value;
    }
  }
  return elementOut;
};

const mergeElement = (elementIn: ElementDesign, elementTemplate: ElementDesign): ElementDesign => {
  const handleFunction = mergeSubElement(elementIn.handleFunction ?? {}, elementTemplate.handleFunction ?? {});
  const condition = mergeSubElement(elementIn.condition ?? {}, elementTemplate.condition ?? {});
  const background = mergeSubElement(elementIn.background ?? {}, elementTemplate.background ?? {});
  const innerSize = mergeSubElement(elementIn.innerSize ?? {}, elementTemplate.innerSize ?? {});

  const elementOut = {...elementTemplate};
  for (const keyToDelete of elementIn.deletedKeys ?? []) {
    deleteKey(keyToDelete, elementOut);
  }

  for (const [key, val] of Object.entries(elementIn)) {
    if (!(['number', 'string', 'boolean'].includes(typeof val)) || val === '') {
      continue;
    }
    elementOut[key] = val;
  }

  elementOut.css = {...elementTemplate.css ?? {}};
  for (const [key, val] of Object.entries(elementIn.css ?? {})) {
    if (val !== undefined && val !== '') {
      elementOut.css[key] = val;
    }
  }

  // @ts-ignore
  elementOut.handleFunction = Object.keys(handleFunction).length > 0 ? handleFunction : undefined;
  // @ts-ignore
  elementOut.condition = Object.keys(condition).length > 0 ? condition : undefined;
  // @ts-ignore
  elementOut.background = Object.keys(background).length > 0 ? background : undefined;
  // @ts-ignore
  elementOut.innerSize = Object.keys(innerSize).length > 0 ? innerSize : undefined;
  elementOut.valueSource = elementIn.valueSource
    ? {...elementTemplate.valueSource, ...elementIn.valueSource}
    : elementTemplate.valueSource;
  elementOut.colorMapping = elementIn.colorMapping
    ? {...elementTemplate.colorMapping, ...elementIn.colorMapping}
    : elementTemplate.colorMapping;
  elementOut.deletedKeys = elementIn.deletedKeys ?? undefined;
  elementOut.templateName = elementIn.templateName;
  elementOut.useTemplate = elementIn.useTemplate;


  for (const deletedKey of elementOut.deletedKeys ?? []) {
    const keySplit = deletedKey.split('.');
    let elemIt = elementOut;
    if (keySplit.length > 1) {
      for (let i = 0; i < keySplit.length - 1; i++) {
        elemIt = elemIt[keySplit[i]];
      }
    }
    delete elemIt[keySplit[keySplit.length - 1]];
  }

  return elementOut;
};


const mergeElements = (elementsIn: Record<string, ElementDesign>, elementsTemplate: Record<string, ElementDesign>)
  : Record<string, ElementDesign> => {
  const mergedElements: Record<string, ElementDesign> = {};

  const keysIn = Object.keys(elementsIn);
  const keysTemplate = Object.keys(elementsTemplate);
  let combinedKeys: string[] = [];

  for (const key of keysTemplate) {
    if (!(keysIn.includes(key))) {
      mergedElements[key] = elementsTemplate[key];
    } else {
      combinedKeys.push(key);
    }
  }

  for (const key of keysIn) {
    if (!(keysTemplate.includes(key))) {
      mergedElements[key] = elementsIn[key];
    } else {
      combinedKeys.push(key);
    }
  }


  combinedKeys = combinedKeys.filter((v, i, a) => a.indexOf(v) === i);


  for (const key of combinedKeys) {
    const elementIn = elementsIn[key];
    const elementTemplate = elementsTemplate[key];
    mergedElements[key] = mergeElement(elementIn, elementTemplate);
  }


  return mergedElements;
};

const mergeTemplates = (pages: AppConfig[]): AppConfig => {
  if (pages.length === 1)  {return _.cloneDeep(pages[0]); }
  const returnPage: AppConfig = _.cloneDeep(pages[0]);
  for (let i = 1; i < pages.length; i++) {
    const page: AppConfig = _.cloneDeep(pages[i]);
    for (const keyToDelete of page.deletedKeys ?? []) {
      const key = getKeyVal(keyToDelete, page);
      if (key !== undefined && key !== null) {
        continue;
      }
      deleteKey(keyToDelete, returnPage);
    }
    const mergedElements = mergeElements(page.design.elements, returnPage.design.elements);
    for (const [key, value] of Object.entries(page.design)) {
      if (typeof value === 'object' && key !== 'elements' && value !== undefined && value !== null) {
        for (const [subKey, subValue] of Object.entries(value)) {
          if (subValue !== undefined && subValue !== null && subValue !== '' && subValue !== 0) {
            if (returnPage.design[key] === undefined) {
              returnPage.design[key] = {};
            }
            returnPage.design[key][subKey] = subValue;
          }
        }

      } else if (typeof value === 'string' && value !== '') {
        returnPage.design[key] = value;
      } else if (typeof value === 'boolean' || typeof value === 'number') {
        returnPage.design[key] = value;

      }
    }

    for (const [key, value] of Object.entries(page.settings)) {
      if (typeof value === 'object' && !Array.isArray(value) && value !== undefined && value !== null) {
        for (const [subKey, subValue] of Object.entries(value)) {
          if (subValue !== undefined && subValue !== null && subValue !== '' && subValue !== 0) {
            if (returnPage.settings[key] === undefined || returnPage.settings[key] === null) {
              returnPage.settings[key] = {};
            }
            returnPage.settings[key][subKey] = subValue;
          }
        }

      } else if (['string', 'number', 'boolean'].includes(typeof value) && value !== '') {
        returnPage.settings[key] = value;
      }
    }


    returnPage.design.elements = mergedElements;
    // returnPage.design.backgroundBounds = {...page.design.backgroundBounds, ...returnPage.design.backgroundBounds};
    // returnPage.design.backgroundSize = {...page.design.backgroundSize, ...returnPage.design.backgroundSize};
    // returnPage.design.orientation = {...page.design.orientation, ...returnPage.design.orientation};
    // returnPage.design.scroll = {...page.design.scroll, ...returnPage.design.scroll};

    returnPage.settings.copyParameters = [...page.settings.copyParameters ?? [], ...returnPage.settings.copyParameters ?? []];
    returnPage.settings.setParameters = [...page.settings.setParameters ?? [], ...returnPage.settings.setParameters ?? []];
    returnPage.settings.templateName = pages[0].settings.templateName;
    returnPage.settings.useTemplate = pages[0].settings.useTemplate;
    returnPage.settings.useDesign = pages[0].settings.useDesign;
  }
  return returnPage;
};

export const fillConfig =
  (config: AppConfig, templates: Record<string, AppConfig>, templatesElements: Record<string, ElementDesign>): AppConfig => {
  let configFilled: AppConfig = _.cloneDeep(config);
  const template = templates[configFilled?.settings?.useTemplate ?? ''];
  if (template !== undefined) {
    configFilled = mergeTemplates([template, configFilled]);
  }

  for (const [key, element] of Object.entries(configFilled.design.elements)) {
    const useTemplate = element.useTemplate;
    if (!useTemplate) {
      continue;
    }
    if (!(Object.keys(templatesElements).includes(useTemplate))) {
      continue;
    }

    configFilled.design.elements[key] = mergeElement(element, templatesElements[useTemplate]);
  }

  for (const key of config?.deletedKeys ?? []) {
    if (key.startsWith('design.elements.')) {
      const keyInner = key.split('design.elements.')[1];
      if (keyInner.includes('.')) {
        deleteKey(keyInner, configFilled.design.elements ?? {});
      }
    }
  }

  return configFilled;
};
